export default function compileOnBound($compile) {
  'ngInject';

  return function link($scope, $element, $attrs) {
    if ('ngBindHtml' in $attrs) {
      $scope.$watch($attrs.ngBindHtml, () => {
        $compile($element.children())($scope);
      });
    }
  };
}
